import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceExtraHappy12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconFaceExtraHappy12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FaceExtraHappy12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m1 0A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-8.25-.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M9 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 9c-.69 0-1.376-.35-1.891-1H7.89c-.514.65-1.2 1-1.89 1m0 1c1.416 0 2.646-.961 3.272-2.374C9.407 7.32 9.167 7 8.833 7H3.167c-.334 0-.574.321-.439.626C3.354 9.039 4.584 10 6 10"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="FaceExtraHappy12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFaceExtraHappy12);
